import React, { PureComponent } from 'react';
import { add as addEvent, remove as removeEvent } from 'bianco.events';
import { subscribe, unsubscribe } from 'util/misc/overlay-tracker';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import classnames from 'classnames';

const MENU_FACET_NAME = 'menu';
const CART_FACET_NAME = 'cart';

class SidePanel extends PureComponent {
    static defaultProps = {
        facet: 'menu',
    };

    static propTypes = {
        pathname: PropTypes.string.isRequired,
        isOpen: PropTypes.bool.isRequired,
        modalContent: PropTypes.any,
        closePanel: PropTypes.func.isRequired,
        resetPanel: PropTypes.func.isRequired,
        facet: PropTypes.string,
        content: PropTypes.object,
        viewportMqWidth: PropTypes.number.isRequired,
    };

    state = {
        isOpening: false,
        isClosing: false,
        isOpen: false,
        facet: null,
    };

    componentDidMount() {
        subscribe(this, this.close);
        addEvent(this.refs.root, 'swipeleft swiperight', this.onSwipe);
    }

    componentWillReceiveProps(nextProps) {
        if (
            (
                nextProps.viewportMqWidth !== this.props.viewportMqWidth ||
                nextProps.pathname !== this.props.pathname ||
                nextProps.modalContent && !this.props.modalContent
            ) && this.props.isOpen
        ) {
            this.close();
        }
    }

    componentWillUpdate(props, state) {
        if (props.isOpen !== this.props.isOpen) {
            state.isOpening = props.isOpen === true;
            state.isClosing = props.isOpen === false;

            if (props.isOpen === true) {
                this.setState({
                    facet: props.facet,
                });
            }
        }
    }

    componentWillUnmount() {
        unsubscribe(this);
        removeEvent(this.refs.root, 'swipeleft swiperight', this.onSwipe);
    }

    onSwipe = (e) => {
        if (
            e.type === 'swipeleft' && this.props.facet === MENU_FACET_NAME ||
            e.type === 'swiperight' && this.props.facet === CART_FACET_NAME) {
            this.close();
        }
    };

    onAnimationEnd = (e) => {
        if (e.target !== this.refs.root) {
            return;
        }

        this.resetPanelState(this.props.facet);
    };

    resetPanelState = (facet) => {
        this.setState({ isOpen: this.props.isOpen, isOpening: false, isClosing: false, facet });

        if (!this.props.isOpen) {
            this.props.resetPanel();
        }
    };

    close = () => {
        this.props.closePanel();
    };

    render() {
        const { content, closePanel } = this.props;
        const { isOpen, isOpening, isClosing, facet } = this.state;

        return (
            <div
                ref="root"
                onAnimationEnd={this.onAnimationEnd}
                className={classnames('side-panel', {
                    [`side-panel__${ facet }`]: facet,
                    'side-panel__open': (isOpen || isOpening || isClosing),
                    'side-panel__opening': isOpening,
                    'side-panel__closing': isClosing,

                })}
                onClick={closePanel}
            >
                <div className='side-panel--panel__background'>
                </div>
                <div
                    className={classnames('side-panel--panel')}
                    onClick={e => e.stopPropagation()}
                >
                    {content}
                </div>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        viewportMqWidth: 'viewport.mq.width',
        isOpen: 'panel.isOpen',
        facet: 'panel.facet',
        modalContent: 'modal.content',
        content: 'panel.content',
        pathname: 'router.location.pathname',
    }),
    reduxUtils.mapDispatchToProps({
        closePanel: 'panel.close',
        resetPanel: 'panel.reset',
    }),
)(SidePanel);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/side-panel/index.js